import { useEffect, useState } from "react";
import { api, apiError, fileUrl } from "@/lib/api";
import { Text, Toggle, Modal, SingleImageEditor } from "@/components/admin/AdminUI";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { image: null, caption: "", order: 0, visible: true };

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/admin/gallery").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.image) { toast.error("Upload an image first"); return; }
    try {
      if (editId) await api.put(`/admin/gallery/${editId}`, form);
      else await api.post("/admin/gallery", form);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (g) => { await api.delete(`/admin/gallery/${g.id}`); load(); };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div><h1 className="font-serif text-3xl text-kys-ink">Gallery</h1><p className="text-sm text-kys-muted">Featured looks shown on the homepage.</p></div>
        <button data-testid="new-gallery-btn" onClick={() => { setForm({ ...empty, order: items.length }); setEditId(null); setOpen(true); }} className="flex items-center gap-1.5 rounded-full bg-kys-ink px-4 py-2 text-sm font-semibold text-white hover:bg-kys-accent"><Plus className="h-4 w-4" /> New</button>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
        {items.map((g) => (
          <div key={g.id} className={`overflow-hidden rounded-lg border border-kys-blush-border bg-white ${g.visible ? "" : "opacity-50"}`}>
            <div className="aspect-[3/4] bg-kys-blush">{g.image && <img src={fileUrl(g.image)} alt={g.caption} className="h-full w-full object-cover" />}</div>
            <div className="flex items-center justify-between p-2">
              <span className="truncate text-xs text-kys-muted">{g.caption || `#${g.order}`}</span>
              <div className="flex gap-2">
                <button onClick={() => { setForm(g); setEditId(g.id); setOpen(true); }} className="text-kys-muted hover:text-kys-accent"><Pencil className="h-4 w-4" /></button>
                <button onClick={() => del(g)} className="text-kys-muted hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={editId ? "Edit Gallery Item" : "New Gallery Item"}>
        <div className="space-y-4">
          <SingleImageEditor label="Image" value={form.image} onChange={(v) => setForm({ ...form, image: v })} />
          <Text label="Caption (optional)" value={form.caption} onChange={(v) => setForm({ ...form, caption: v })} />
          <Text label="Order" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: v })} />
          <Toggle label="Visible" checked={form.visible} onChange={(v) => setForm({ ...form, visible: v })} />
          <button data-testid="save-gallery" onClick={save} className="w-full rounded-full bg-kys-ink py-3 text-sm font-semibold text-white hover:bg-kys-accent">Save</button>
        </div>
      </Modal>
    </div>
  );
}
